import { render, staticRenderFns } from "./Iconfont.vue?vue&type=template&id=b168dafc&scoped=true&"
import script from "./Iconfont.vue?vue&type=script&lang=js&"
export * from "./Iconfont.vue?vue&type=script&lang=js&"
import style0 from "./Iconfont.vue?vue&type=style&index=0&id=b168dafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b168dafc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b168dafc')) {
      api.createRecord('b168dafc', component.options)
    } else {
      api.reload('b168dafc', component.options)
    }
    module.hot.accept("./Iconfont.vue?vue&type=template&id=b168dafc&scoped=true&", function () {
      api.rerender('b168dafc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Iconfont.vue"
export default component.exports